import { NgModule } from '@angular/core';
import { CardCarouselComponent } from './card-carousel.component';
import { BannerModule } from './components/banner/banner.module';
import { SimplePaginatorModule } from './components/simple-paginator/simple-paginator.module';

@NgModule({
  declarations: [CardCarouselComponent],
  imports: [BannerModule, SimplePaginatorModule],
  exports: [CardCarouselComponent]
})
export class CardCarouselModule {}
